export const OrgsAdminDashboard = 'OrgsAdminDashboard';
export const OrgAdminSettings = 'OrgAdminSettings';
export const OrgAdminClubDashboard = 'OrgAdminClubDashboard';
export const OrgAdminManagePlayers = 'OrgAdminManagePlayers';
export const OrgAdminManageStaff = 'OrgAdminManageStaff';
export const OrgAdminManageLandingPage = 'OrgAdminManageLandingPage';

export const TeamDashboard = 'TeamDashboard';
export const TeamCreate = 'TeamCreate';
export const TeamEventCreate = 'TeamEventCreate';
export const TeamEventEdit = 'TeamEventEdit';
export const EditTeam = 'EditTeam';
export const ShareTeam = 'ShareTeam';